import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { tv } from 'tailwind-variants';

import { SecondaryTabsList, SecondaryTabsTrigger } from '@/components/ui/secondary-tab.component';
import { TabItem, TabsType } from '@/app/(main)/(pages)/busca/[slug]/_hooks/use-schedule-tab.hook';

interface HeaderTabProps {
  tabs: TabItem[];
}

const tab = tv({
  slots: {
    trigger: 'flex-1 w-full',
  },

  variants: {
    type: {
      [TabsType.STANDALONE]: {},

      [TabsType.FLEX]: {},

      [TabsType.WHATSAPP]: {},

      [TabsType.SCHEDULED]: {},

      [TabsType.ARRIVAL_ORDER]: {
        trigger: 'ml-4 sm:ml-0',
      },
    },

    hasFlex: {
      true: {},
    },

    hasStandalone: {
      true: {},
    },

    hasScheduled: {
      true: {},
    },

    hasArrivalOrder: {
      true: {},
    },
  },

  compoundVariants: [
    {
      type: TabsType.STANDALONE,
      hasFlex: false,
      className: {
        trigger: 'block md:block',
      },
    },

    {
      type: TabsType.FLEX,
      hasStandalone: false,
      className: {
        trigger: 'block md:block',
      },
    },

    {
      type: TabsType.WHATSAPP,
      hasStandalone: false,
      className: {
        trigger: 'block md:block',
      },
    },

    {
      type: TabsType.STANDALONE,
      hasFlex: true,
      hasStandalone: true,
      className: {
        trigger: 'hidden md:block',
      },
    },

    {
      type: TabsType.FLEX,
      hasFlex: true,
      hasStandalone: true,
      className: {
        trigger: 'hidden md:block',
      },
    },

    {
      type: TabsType.WHATSAPP,
      hasFlex: true,
      hasStandalone: true,
      className: {
        trigger: 'hidden md:block',
      },
    },

    {
      type: TabsType.STANDALONE,
      hasFlex: false,
      hasStandalone: true,
      hasScheduled: true,
      hasArrivalOrder: true,
      className: {
        trigger: 'whitespace-break-spaces max-w-20 pre-mobile:max-w-full',
      },
    },

    {
      type: TabsType.SCHEDULED,
      hasFlex: false,
      hasStandalone: true,
      hasScheduled: true,
      hasArrivalOrder: true,
      className: {
        trigger: 'whitespace-break-spaces max-w-20 pre-mobile:max-w-full',
      },
    },

    {
      type: TabsType.ARRIVAL_ORDER,
      hasFlex: false,
      hasStandalone: true,
      hasScheduled: true,
      hasArrivalOrder: true,
      className: {
        trigger: 'whitespace-break-spaces max-w-20 pre-mobile:max-w-full',
      },
    },
  ],
});

type PossibleTabKey = Exclude<TabsType, TabsType.LABORATORIAL>;

export function HeaderTab({ tabs }: HeaderTabProps) {
  const { trigger } = tab();

  const tabsKeys = tabs?.map((tab) => tab.key) || [];

  const hasFlex = tabsKeys.includes(TabsType.FLEX) || tabsKeys.includes(TabsType.WHATSAPP);
  const hasStandalone = tabsKeys.includes(TabsType.STANDALONE);
  const hasScheduled = tabsKeys.includes(TabsType.SCHEDULED);
  const hasArrivalOrder = tabsKeys.includes(TabsType.ARRIVAL_ORDER);

  return (
    <SecondaryTabsList className="pb-5">
      {tabs.map((tab) => {
        return (
          <SecondaryTabsTrigger
            key={tab.key}
            value={tab.key}
            className={trigger(
              { type: tab.key as PossibleTabKey, hasFlex, hasStandalone, hasScheduled, hasArrivalOrder })}
            data-testid={`${DataTestIdEnum.SEARCH_SCHEDULE_MODAL_TAB_TRIGGER}-${tab.key}`}
          >
            {tab.title}
          </SecondaryTabsTrigger>
        );
      })}
    </SecondaryTabsList>
  );
}
